import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CCallout } from "@coreui/react";
const PasswordRequirements = () => {
    return (_jsx(CCallout, Object.assign({ color: "warning" }, { children: _jsxs("ul", { children: [_jsx("li", { children: "8-24 karakter hossz\u00FA legyen" }), _jsx("li", { children: "Tartalmazzon kis bet\u0171t, nagy bet\u0171t, sz\u00E1mot" })] }) })));
};
export default PasswordRequirements;
